import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { requestUpdateProductSet } from "./updateProductSet.request";

const useCreateProductSet = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchProductSets = useRefetchQuery(["product-sets"]);

  return useMutation({
    mutationFn: requestUpdateProductSet,
    ...options,
    onSuccess: (...args) => {
      refetchProductSets();
      options?.onSuccess?.(...args);
    }
  });
};

export default useCreateProductSet;
